export default [
  {
    path: '/raporharitapersonel',
    name: 'raporharitapersonel-list',
    component: () => import('./index.vue'),
    meta: {
      public: false,
      title: 'raporharitapersonel.Baslik',
      yetki: { k: [2000602] },
    },
  },
]
